import { http } from "../../components/services/httpService";

export async function uploadPdf( pdfFile, filename, email ) {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const fullPdfUrl = `${ baseUrl }resumes/pdf-uploads/${ encodeURIComponent( filename ) }`;

    const formData = new FormData();
    formData.append( "file", pdfFile, filename );
    formData.append( "email", email );
    formData.append( "pdfUrl", fullPdfUrl );

    const options = {
        method: "POST",
        body: formData,
        headers: {}
    }

    const response = await http( 'resumes/upload-pdf', options );
    if ( !response.ok ) {
        console.error( 'Failed to upload resume pdf:', response.status );
        throw new Error( `Failed to upload resume pdf: ${ response.status }` );
    }

    return fullPdfUrl;
}
